var path = 'components/contentTypeGroupSearchResults/contentTypeGroupSearchResults.template.html';
var html = "<smb-document-hit-list documents=vm.contentSearchDS.documents view-on-select=true></smb-document-hit-list>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/contentTypeGroupSearchResults/contentTypeGroupSearchResults.template.html
// module id = 172
// module chunks = 1